import React from 'react';
import './index.scss';
const TextDialog = props => {
	console.log(props.text);
	return (
		<div className="text-dialog-wrapper">
			<div className="text-dialog-content">
				<header className="text-dialog-header">{props.title}</header>
				{typeof props.text === 'string' ? <div className="text-dialog-text" dangerouslySetInnerHTML={{ __html: props.text }}></div> : <div className="text-dialog-text">{props.text}</div>}
				<footer className="text-dialog-footer" onClick={props.clickFooter}>
					{props.footer}
				</footer>
			</div>
		</div>
	);
};
export { TextDialog };
